export default __webpack_public_path__ + "static/media/mountains-blue.2162f78a.svg";